module.exports = "/media/link_white.fa26030c.png";